import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function TermsOfServicePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section - Mismo estilo que Home */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">

          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            Terms of Service
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            Please read these terms carefully before using our services
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Last Updated: {new Date().getFullYear()}
          </p>
        </div>
      </section>

      {/* Terms Highlights */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">V</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Acceptance</h3>
              <p className="text-gray-600">
                By using our services, you agree to these terms and conditions.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">R</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Usage Rights</h3>
              <p className="text-gray-600">
                Personal use license for all purchased digital products.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">X</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Restrictions</h3>
              <p className="text-gray-600">
                No redistribution, resale, or commercial use without permission.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Terms Details */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-8">
              Terms and Conditions
            </h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">1.</span>
                  Acceptance of Terms
                </h3>
                <div className="bg-gray-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    By accessing and using Vencejo Academy's website, products, and services, you accept and agree to be bound by 
                    the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">2.</span>
                  Use License
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    Permission is granted to temporarily download one copy of the materials on Vencejo Academy's website for personal, 
                    non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                  </p>
                  <ul className="space-y-2 text-gray-700 mt-4">
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Modify or copy the materials</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-600 mr-3 mt-1">•</span>
                      <span>Use the materials for any commercial purpose or for any public display</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-600 mr-3 mt-1">•</span>
                      <span>Attempt to reverse engineer any software contained on Vencejo Academy's website</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-600 mr-3 mt-1">•</span>
                      <span>Remove any copyright or other proprietary notations from the materials</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-600 mr-3 mt-1">•</span>
                      <span>Transfer the materials to another person or "mirror" the materials on any other server</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">3.</span>
                  Account Registration
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    When you create an account with us, you must provide information that is accurate, complete, and current at all times. 
                    You are responsible for safeguarding the password and for all activities that occur under your account.
                  </p>
                  <ul className="space-y-2 text-gray-700 mt-4">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span>You must not use the service for any illegal or unauthorized purpose</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-3 mt-1">•</span>
                      <span>You must not violate any laws in your jurisdiction</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-3 mt-1">•</span>
                      <span>You must not transmit any worms or viruses or any code of a destructive nature</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">4.</span>
                  Payment Terms
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    All purchases are final unless otherwise stated. Payment must be made in full at the time of purchase. 
                    We accept various payment methods including credit cards, PayPal, and other secure payment processors.
                  </p>
                  <ul className="space-y-2 text-gray-700 mt-4">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">•</span>
                      <span>All prices are in USD unless otherwise specified</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-600 mr-3 mt-1">•</span>
                      <span>You are responsible for any applicable taxes</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-600 mr-3 mt-1">•</span>
                      <span>Refunds are subject to our Refund Policy</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">5.</span>
                  Intellectual Property
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    All content, including but not limited to text, graphics, logos, images, audio clips, digital downloads, 
                    and software, is the property of Vencejo Academy or its content suppliers and is protected by international copyright laws.
                  </p>
                  <p className="text-gray-700 mt-4">
                    You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, 
                    republish, download, store, or transmit any of the material on our website without prior written consent.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">6.</span>
                  Prohibited Uses
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700 mb-4">
                    You may not use our service:
                  </p>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">-</span>
                      <span>In any way that violates any applicable national or international law or regulation</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">-</span>
                      <span>To transmit, or procure the sending of, any advertising or promotional material without our prior written consent</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">-</span>
                      <span>To impersonate or attempt to impersonate the company, a company employee, another user, or any other person or entity</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-red-600 mr-3 mt-1">-</span>
                      <span>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">7.</span>
                  Disclaimer
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    The materials on Vencejo Academy's website are provided on an 'as is' basis. Vencejo Academy makes no warranties, 
                    expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, 
                    implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement 
                    of intellectual property or other violation of rights.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">8.</span>
                  Limitation of Liability
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    In no event shall Vencejo Academy or its suppliers be liable for any damages (including, without limitation, 
                    damages for loss of data or profit, or due to business interruption) arising out of the use or inability 
                    to use the materials on Vencejo Academy's website, even if Vencejo Academy or an authorized representative has been 
                    notified orally or in writing of the possibility of such damage.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">9.</span>
                  Changes to Terms
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision 
                    is material, we will provide at least 30 days notice prior to any new terms taking effect. What constitutes 
                    a material change will be determined at our sole discretion.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">10.</span>
                  Contact Information
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <p className="text-gray-700">
                    If you have any questions about these Terms of Service, please contact us at{' '}
                    <a href="mailto:legal@espanolhub.com" className="text-primary-600 hover:underline">legal@espanolhub.com</a> or 
                    through our <Link to="/contact" className="text-primary-600 hover:underline">contact page</Link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-5xl mb-6">Contact</div>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            Questions About Our Terms?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            If you have any questions about these Terms of Service, please don't hesitate to contact us.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition transform hover:scale-105 shadow-lg"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
}

export default TermsOfServicePage;

